import axios from "axios";
import { authenticatedHeader } from "../../DefaultConfig";
import { StatisticsURL } from "../../Services";
import { HideAwaiting, ShowAwaiting } from "../../../util/Awaiting";

export async function countByTopicsLastXDays(x:number) {
  ShowAwaiting();
  var res = await axios.get(
    StatisticsURL +
    "api/statistics/overall/topic/last-x-days/" +
    String(x)
    , authenticatedHeader()
  );
  HideAwaiting();
  return res.data;
}
